import * as React from "react";
import PopupStyle from "../Styled/Popup.style";
import Popover from "@mui/material/Popover";

export default function Popup({
  anchor,
  open,
  title,
  body,
  action,
  variant,
  onClose,
  anchorOrigin,
}) {
  const id = open ? "generic-popover" : undefined;

  return (
    <>
      <Popover
        id={id}
        open={open}
        anchorEl={anchor}
        anchorOrigin={
          anchorOrigin || {
            vertical: "bottom",
            horizontal: "left",
          }
        }
        onClose={onClose}
        PaperProps={{ sx: { overflow: "visible" } }}
      >
        <PopupStyle variant={variant}>
          <div className="heading">{title}</div>
          <div className="body">{body}</div>
          {action}
        </PopupStyle>
      </Popover>
    </>
  );
}
